import { twMerge } from 'tailwind-merge';

type PlaceholderProps = React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
};

export const Placeholder = ({ className = '', ...props }: PlaceholderProps) => (
  <div className={twMerge('animate-pulse duration-[3s] ease-in-out bg-base-100 mb-6 w-[100%]', className)} {...props} />
);
